export default __webpack_public_path__ + "static/media/wide-range-gray.c88f721f.svg";